// Module
var code = "<select class=\"form-control\" ng-model=\"vm.value\"> <option ng-repeat=\"option in filteredOptions\" value=\"{{String(option.id)}}\"> {{ option|translateProperty:'name' }} </option> </select> ";
// Exports
module.exports = code;